import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import WarrantDictModel from '../models/warrantyDict.model';
import { Input } from '../../common/components';
import { getWarrantyDict, saveWarrantyDict } from '../services/dictionary.service';

class DictWarrantyForm extends PureComponent {
  state = {
    name: '',
    duration: 0,
    active: true,
    year_limit: undefined,
    mileage_limit: undefined,
  };

  async componentDidMount() {
    const { match: { params } } = this.props;

    if (params.id) {
      const warrantyDict = await getWarrantyDict(params.id);

      this.setState({
        ...warrantyDict,
      });
    }
  }

  onInputChange = (name, value) => this.setState({ [name]: value });

  onCompanyGroupChange = (_, companyGroup) => {
    this.setState({
      groups: companyGroup,
    });
  }

  handleSave = async () => {
    try {
      const warrantyModel = new WarrantDictModel({ ...this.state });
      const errors = warrantyModel.validate();

      if (!errors) {
        await saveWarrantyDict(this.state);

        this.props.history.push('/dictionary/warranties');
      }

      this.setState({ errors });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const {
      name,
      duration,
      active,
      year_limit,
      mileage_limit,
      errors,
    } = this.state;
    return (
      <>
        <div className="content">
          <div className="card">
            <div className="card-body">
              <div className="form-horizontal">
                <Input
                  id="name"
                  label="Nazwa gwarancji"
                  value={name}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />
                <Input
                  id="duration"
                  label="Czas trwania [w miesiącach]"
                  value={duration}
                  errors={errors}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="year_limit"
                  label="Limit wieku samochodu [w latach]"
                  value={year_limit}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />
                <Input
                  id="mileage_limit"
                  label="Limit przebiegu [w km]"
                  value={mileage_limit}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />
                <Input
                  id="active"
                  label="Aktywna"
                  value={active}
                  onChange={this.onInputChange}
                  errors={errors}
                  type="checkbox"
                  horizontal
                />
              </div>
              <div className="form-group">
                <button
                  type="button"
                  onClick={this.handleSave}
                  className="btn btn-primary float-right"
                >
                  <i className="fa fa-check" />
                  {' '}
                  Zapisz
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

DictWarrantyForm.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(DictWarrantyForm);
